import { ClientAgentProduct, Model } from "@/models";
import ClientCompany from "./Company";
import ClientAgency from "./Agency";
import ClientAgent from "./Agent";

class AssociationDuplicateAgentCompany {
  agentCode!: string;
  agentType!: string;

  agentStartDate!: string;
  agentEndDate?: string;

  get parsedAgentStartDate(): Date {
    return new Date(this.agentStartDate);
  }
  get parsedAgentEndDate(): Date | null {
    if (!this.agentEndDate) {
      return null;
    }

    return new Date(this.agentEndDate);
  }
}

export default class AgentCompanyAssociationDuplicate extends Model {
  static type = "clientsAgentCompanyAssociationDuplicates";

  agencyAgentEndDate?: string;
  agencyAgentId?: string;
  agencyAgentStartDate?: string;
  agencyEndDate?: string;
  agencyId?: string;
  agencyStartDate?: string;
  agentCompanyId!: string;
  idSelected?: string;
  mediaId!: number;
  agentProductId?: string;

  agentCompany!: ClientCompany;
  agentProduct?: ClientAgentProduct;
  agency?: ClientAgency;
  agencyAgent?: ClientAgent;
  agentCompanyAgents!: AssociationDuplicateAgentCompany[];
}
